const skuList = [
    'GRB224P10954',
    'GRB107P4303',
    'GRB354P10532',
    'GRB371P10947',
    'GRB99P10888',
    'GRB120P10818',
    'GRB18P4495',
    'GRB357P10564',
    'GRB59P10387',
    'GRB59P10499',
    'GRB99P10887',
    'GRB18P3798',
    'GRB224P10863',
    'GRB131P11083',
    'GRB41P11301',
    'GRB385P11262',
    'GRB59P10522',
    'GRB120P10817',
    'GRB59P10386',
    'GRB59P10566',
    'GRB107P4298',
    'GRB359P10593',
    'GRB59P11013',
    'GRB357P10577',
    'GRB164P10496',
    'GRB380P4512',
    'GRB339P10483',
    'GRB59P10519',
    'GRB59P4318',
    'GRB175P10561',
    'GRB155P10007',
    'GRB131P11090',
    'GRB141P11302',
    'GRB87P4293',
    'GRB43P4064',
    'GRB59P4321',
    'GRB154P10770',
    'GRB352P10498',
    'GRB69P2337',
    'GRB40P11323',
    'GRB155P11383',
    'GRB111P2307',
    'GRB129P11381',
    'GRB129P11382',
    'GRB120P11290',
    'GRB129P11380',
    'GRB221P11267',
    'GRB120P11291',
    'GRB120P11295',
    'GRB278P9915',
    'GRB40P10526',
    'GRB18P1854',
    'GRB83P10321',
    'GRB9P10113',
    'GRB175P10560',
    'GRB59P10521',
    'GRB59P11483',
    'GRB89P3930',
    'GRB146P11356',
    'GRB59P11410',
    'GRB59P11411',
    'GRB9P11633',
    'GRB224P10033',
    'GRB18P798',
    'GRB69P4419',
    'GRB156P10286',
    'GRB221P11271',
    'GRB156P11247',
    'GRB156P10284',
    'GRB221P11270',
    'GRB164P10956',
    'GRB9P10840',
    'GRB150P3271',
    'GRB383P11208',
    'GRB387P11436',
    'GRB83P11209',
    'GRB392P11427',
    'GRB154P10761',
    'GRB83P10320',
    'GRB74P3978',
    'GRB319P10043',
    'GRB29P11179',
    'GRB185P11202',
    'GRB146P10565',
    'GRB29P11555',
    'GRB29P11552',
    'GRB29P11554',
    'GRB29P11553',
    'GRB29P10925',
    'GRB126P11108',
    'GRB40P11210',
    'GRB146P10572',
    'GRB185P11259',
    'GRB120P10542',
    'GRB224P10035',
    'GRB18P3269',
    'GRB59P11403',
    'GRB129P11398',
    'GRB129P11404',
    'GRB59P11402',
    'GRB111P3942',
    'GRB111P3941',
    'GRB111P2308',
    'GRB131P10948',
    'GRB156P10288',
    'GRB156P10438',
    'GRB78P3658',
    'GRB89P3661',
    'GRB343P3999',
    'GRB382P11207',
    'GRB69P11199',
    'GRB206P10793',
    'GRB9P10376',
    'GRB59P4385',
    'GRB59P10078',
    'GRB59P4320',
    'GRB59P10520',
    'GRB146P10575',
    'GRB146P10576',
    'GRB146P10444',
    'GRB236P10933',
    'GRB224P10864',
    'GRB156P10289',
    'GRB192P11326',
    'GRB131P11082',
    'GRB69P10919',
    'GRB120P10816',
    'GRB131P10338',
    'GRB92P10390',
    'GRB59P10568',
    'GRB59P10069',
    'GRB94P4454',
    'GRB149P4302',
    'GRB78P4237',
    'GRB43P491',
    'GRB144P10881',
    'GRB126P10201',
    'GRB9P10377',
    'GRB59P4386',
    'GRB126P11172',
    'GRB29P10080',
    'GRB239P4285',
    'GRB348P10492',
    'GRB214P11128',
    'GRB5P9786',
    'GRB59P10525',
    'GRB69P3954',
    'GRB111P3940',
    'GRB131P10950',
    'GRB94P4448',
];

export const isTrialProduct = (sku) => skuList.includes(sku);
